import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LogoComponent } from '@/components/layout/logo/logo.component';
import { eThemeLeptonXComponents } from '@volosoft/abp.ng.theme.lepton-x';
import { AuthService, ReplaceableComponentsService } from '@abp/ng.core';
import { UserComponent } from './users/user/user.component';
import { eIdentityComponents } from '@volo/abp.ng.identity';
import { ThemeService, StyleNames, lightTheme } from '@volosoft/ngx-lepton-x';
import { AppMobileNavbarComponent } from './components/layout/mobile/mobile-navbar.component';

@Component({
    selector: 'app-root',
    /**
     * `changeDetection` and `standalone` are both stated explicitly because
     * Angular 22 changed what omitting them means: a component that declares
     * neither is now OnPush and standalone. `Eager` is the pre-v22 `Default`
     * (CheckAlways), so naming it keeps this component behaving exactly as it
     * did before the upgrade instead of silently inheriting a new strategy.
     *
     * This is a migration guard, not a recommendation. Components move to
     * OnPush deliberately and one at a time - by reworking the component to
     * signals, the `async` pipe or `markForCheck()` and then changing this
     * value, never by simply deleting the line.
     */
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
      <abp-loader-bar></abp-loader-bar>
      <abp-dynamic-layout></abp-dynamic-layout>
      <abp-gdpr-cookie-consent></abp-gdpr-cookie-consent>
      <!--
        Mounted here rather than on the pages that start exports: a background export
        outlives the page that asked for it, and the tray has to be there to hand the
        file over when it finishes.
      -->
      <app-report-job-tray></app-report-job-tray>
    `,
    standalone: false
})
export class AppComponent {
  constructor(
    private replaceableComponents: ReplaceableComponentsService,
    private auth: AuthService,
    private themeService: ThemeService,
  ) {
    this.replaceableComponents.add({
      component: AppMobileNavbarComponent,
      key: eThemeLeptonXComponents.MobileNavbar,
    });
    this.replaceableComponents.add({
      component: LogoComponent,
      key: eThemeLeptonXComponents.Logo,
    });
    this.replaceableComponents.add({
      component: UserComponent,
      key: eIdentityComponents.Users,
    });

    if (this.themeService.selectedStyle.styleName != StyleNames.Light) {
      this.themeService.setTheme(lightTheme);
    }
  }

  get hasLoggedIn(): boolean {
    return this.auth.isAuthenticated;
  }

  onMove() {
    window.scrollTo({ top: 0 });
  }

  login() {
    this.auth.navigateToLogin();
  }
}
